import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SocialInstagram = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.243 28 4 25.757 4 23V9C4 6.243 6.243 4 9 4H23C25.757 4 28 6.243 28 9V23C28 25.757 25.757 28 23 28ZM9 6C7.346 6 6 7.346 6 9V23C6 24.654 7.346 26 9 26H23C24.654 26 26 24.654 26 23V9C26 7.346 24.654 6 23 6H9Z" />
		<path d="M16 22C12.691 22 10 19.308 10 16C10 12.692 12.691 10 16 10C19.309 10 22 12.691 22 16C22 19.309 19.308 22 16 22ZM16 12C13.794 12 12 13.794 12 16C12 18.206 13.794 20 16 20C18.206 20 20 18.206 20 16C20 13.794 18.206 12 16 12Z" />
		<path d="M24 9.125C24 9.677 23.552 10.125 23 10.125C22.448 10.125 22 9.677 22 9.125C22 8.573 22.448 8.125 23 8.125C23.552 8.125 24 8.573 24 9.125Z" />
	</svg>
);

export default SocialInstagram;
